import { FeedItem } from "../shared/achievements";
import { byId, flashToast } from "./dom";
import { t } from "./i18n";
import { canUse } from "./me";
import { showView } from "./navigation";
import { feedItems, isNew, lastSeen, loadFeed, onFeed, postToFeed, watchFeed, whenLabel } from "./feed_store";
import { feedLine } from "./views/feed_view";

// the feed on home: the latest few entries and a box to post one. the feed screen has the rest.
// kept to its own markup (#today-board, from when this was the message board) so the home layout can move it anywhere

const SHOWN = 3;

function row(item: FeedItem, seen: string): HTMLElement {
  const line = document.createElement("li");
  line.className = `board-line${isNew(item, seen) ? " fresh" : ""} compact`;
  const tag = document.createElement("span");
  tag.className = "board-tag";
  tag.textContent = (item.name.trim().slice(0, 2) || "?").toUpperCase();
  tag.setAttribute("aria-hidden", "true");
  const body = document.createElement("div");
  body.className = "board-body";
  const head = document.createElement("div");
  head.className = "board-head";
  const who = document.createElement("b");
  who.textContent = item.name || t("someone");
  const when = document.createElement("time");
  when.dateTime = item.at;
  when.textContent = whenLabel(item.at);
  head.append(who, when);
  const text = document.createElement("p");
  text.className = "board-text";
  text.textContent = feedLine(item);
  body.append(head, text);
  line.append(tag, body);
  return line;
}

function paint(items: FeedItem[]): void {
  const seen = lastSeen();
  const latest = items.slice(0, SHOWN);
  byId("today-board-list").replaceChildren(...latest.map((item) => row(item, seen)));
  byId("today-board-empty").hidden = latest.length > 0;
  byId("today-board-count").textContent = items.length > SHOWN ? t("+{n} more", { n: items.length - SHOWN }) : "";
  byId("today-board").classList.toggle("has-fresh", items.some((item) => isNew(item, seen)));
}

async function submit(event: Event): Promise<void> {
  event.preventDefault();
  const input = byId<HTMLInputElement>("today-board-input");
  if (!input.value.trim()) return input.focus();
  try {
    await postToFeed(input.value);
    input.value = "";
  } catch (error) {
    flashToast(error instanceof Error ? t(error.message.replace(/^.*Error: /, "")) : t("couldn't post that"));
  }
}

export function setupFeedTile(): void {
  if (!canUse("board")) return;
  watchFeed();
  onFeed(paint);
  byId("today-board-open").addEventListener("click", () => showView("feed"));
  byId("today-board-list").addEventListener("click", () => showView("feed"));
  const form = byId("today-board-form");
  form.hidden = !canUse("board", "edit");
  form.addEventListener("submit", submit);
}

// call when home is shown, the first time loads and later ones repaint the "now / 5m" times
export function refreshFeedTile(): void {
  if (!canUse("board")) return;
  void loadFeed(true).then(() => paint(feedItems()));
}
